<div class="w-100 h-100" *ngIf="!globalVariables.isPageSmall" [innerHTML]='html_desktop'>
</div>

<div class="w-100 h-100" *ngIf="globalVariables.isPageSmall" [innerHTML]='html_mobile'>
</div>


<!-- <div class="check-access-container">
  <div class="w-100 h-100 p-relative  d-flex">
    <div class="" style="max-height: 100%;max-width: 100%;margin: auto;position: relative;"
      [ngClass]="(window.innerWidth > window.innerHeight) ? 'h-100' : 'w-100'">
      <img src="/assets/welcomePageResources/cover.jpg" style="max-height: 100%;max-width: 100%;height:100%" alt="">
      <div class="w-100 h-100 d-flex justify-content-center">
        <div style="position: absolute; bottom: 15%; color: black; font-size: large;">
          <div *ngIf="options!=null">
            <span class="row g-0 justify-content-center">{{options.paragraph1}}</span>
            <span class="row g-0 justify-content-center">{{options.paragraph2}}</span>
            <div class="row g-0 mt-1" *ngIf="codeType != null">
              <div class="col-8 pe-2">
                <input [type]="codeType" name="code" id="code" placeholder="clave" [(ngModel)]='code' class="w-100"
                  autocomplete="off" style="background-color: white; color: black; height: 2em; border-radius: 5px !important;" (keydown.enter)="checkAccess()">
              </div>
              <div class="col-4 ps-2">
                <button type="button" class='w-100 h-100 btn' style="background-color: white; font-size: 14px; border-radius: 5px !important;" (click)="checkAccess()">Acceder</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div> -->